import React from "react";
import { Box, Typography } from "@mui/material";
import { Document, FileToUpload, Profile } from "../types";
import DocumentUploadSection from "./DocumentUploadSection";
import SelectedFilesList from "./SelectedFilesList";
import EmploymentTypeSelector from "./EmploymentTypeSelector";
import { useTranslation } from "react-i18next";
import DocumentUploadPanel from "../../../submodules/document-uploader/DocumentUploadPanel";

interface DocumentUploaderProps {
  documents: Document[];
  filesToUpload: FileToUpload[];
  handleFileChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    documentType: string
  ) => void;
  removeFile: (index: number) => void;
  uploadFiles: () => void;
  handleViewDocument: (document: Document) => void;
  profile: any;
  employmentType: string;
  handleEmploymentTypeChange: any;
}

const DocumentUploader: React.FC<DocumentUploaderProps> = ({
  documents,
  filesToUpload,
  handleFileChange,
  removeFile,
  uploadFiles,
  handleViewDocument,
  profile,
  employmentType,
  handleEmploymentTypeChange,
}) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            mb: 3,
            fontWeight: 500,
            letterSpacing: "0.5px",
            color: "text.primary",
            position: "relative",
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: -8,
              left: 0,
              width: "40px",
              height: "2px",
              background: "linear-gradient(90deg, #1976d2, transparent)",
              borderRadius: "2px",
            },
          }}
        >
          {t("screening_profile.documents")}
        </Typography>
        <EmploymentTypeSelector
          profile={profile}
          handleEmploymentTypeChange={handleEmploymentTypeChange}
        />
      </Box>
      {/* <DocumentUploadSection
        documents={documents}
        onFileChange={handleFileChange}
        onViewDocument={handleViewDocument}
        employmentType={employmentType}
      /> */}
      <DocumentUploadPanel
        documents={documents}
        onFileChange={handleFileChange}
        onViewDocument={handleViewDocument}
        employmentType={employmentType}
        platform={"TENANT"}
      />
      <SelectedFilesList
        filesToUpload={filesToUpload}
        onRemoveFile={removeFile}
        onUploadFiles={uploadFiles}
      />
    </Box>
  );
};

export default DocumentUploader;
